var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-header"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('COMMON_UPLOAD'))+"\n    ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }